export default __webpack_public_path__ + "static/media/The Doctor.651dbf47.png";